// src/pages/auth/ClientPandaDocs.jsx
import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, CardHeader, Container } from "reactstrap";
import toastr from "toastr";
import { useDispatch, useSelector } from "react-redux";
import withRouter from "../../components/Common/withRouter";
import { setOnboardingComplete } from "../../store/auth/actions";
import { selectAgreementLink } from "../../store/common/selectors";
import CustomHeader from "../../components/Auth/CustomHeader";

const ClientPandaDocs = (props) => {
  document.title = "Client Onboarding | JobArk";

  const dispatch = useDispatch();
  const agreementLink = useSelector(selectAgreementLink);

  const [onboarded, setOnboarded] = useState(false);
  const [clientName, setClientName] = useState("");

  useEffect(() => {
    if (!agreementLink) return;

    const onMessage = (event) => {
      try {
        const originHost = new URL(event.origin).hostname;
        if (!/\.pandadoc\.com$/.test(originHost)) return;

        const payload = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        const type = payload?.type;

        const COMPLETED_TYPES = new Set([
          "session_view.document.completed",
          "document.completed",
          "recipient.completed",
          "session_view.completed",
          "embed.form.completed"
        ]);

        if (COMPLETED_TYPES.has(type)) {
          setOnboarded(true);
          dispatch(setOnboardingComplete(true));
          toastr.success("Agreements completed. Thank you!");
          props.router.navigate("/");
        }
      } catch {
        // ignore non-JSON or unrelated messages
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [agreementLink, dispatch, props.router]);

  return (
    <>
      <CustomHeader />

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={10} lg={8} xl={7}>
              <Card>
                <CardHeader className="bg-primary">
                  <h4 className="text-white mb-0 text-center py-2">
                    {onboarded ? "Thank You!" : "Client Agreements & Declarations"}
                  </h4>
                </CardHeader>

                <CardBody>
                  {onboarded ? (
                    <>
                      <h5 className="mb-3">{clientName ? `Hi ${clientName},` : "Hi,"}</h5>
                      <p className="mb-2">
                        Thank you for completing your onboarding. Your agreements have been
                        received.
                      </p>
                      <p className="mb-0">— JobArk Team</p>
                    </>
                  ) : agreementLink ? (
                    <iframe
                      title="PandaDoc"
                      src={agreementLink}
                      style={{ border: "none", width: "100%", height: "80vh" }}
                      allow="clipboard-read; clipboard-write; fullscreen; display-capture"
                      allowFullScreen
                    />
                  ) : (
                    <p>Loading PandaDoc…</p>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default withRouter(ClientPandaDocs);
